// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1QYZD","col":"styles_col__3zfkZ"};